<template>
  <el-form ref="form" :model="formData" :rules="rules">
    <el-row :gutter="20">
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_attribute_type') || '属性类型'"
          prop="resAttributeType"
        >
          <el-input
            v-model="formData.resAttributeType"
            disabled
            size="medium"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_status') || '有效状态'"
          prop="resAttributeStatus"
        >
          <el-radio-group
            size="medium"
            style="width: 100%"
            disabled
            v-model="formData.resAttributeStatus"
          >
            <el-radio label="Y">{{
              $l("INDEX.form_label_valid") || "有效"
            }}</el-radio>
            <el-radio label="N">{{
              $l("INDEX.form_label_invalid") || "无效"
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_name_cn') || '中文名称'"
          prop="resAttributeName"
        >
          <el-input
            v-model="formData.resAttributeName"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_name_en') || '英文名称'"
          prop="resAttributeNameEn"
        >
          <el-input
            v-model="formData.resAttributeNameEn"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :sm="{ span: 12 }" :md="{ span: 12 }" :lg="{ span: 12 }">
        <el-form-item
          :label="$l('form_label_remarks') || '属性说明'"
          prop="resAttributeDescription"
        >
          <el-input
            v-model="formData.resAttributeDescription"
            clearable
            size="medium"
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col v-if="createDateVisible">
        <div style="font-size: 14px; color: #606266">
          <span
            >Create：{{ formData.createByName }} at
            {{ formData.createDate }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span
            >Modify：{{ formData.modifyByName }} at
            {{ formData.modifyDate }}</span
          >
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    createDateVisible:Boolean,
    resAttributeType: String,
    resAttributeCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        resAttributeStatus: "Y",
        resAttributeType:this.resAttributeType,
      },
      rules: {
        resAttributeType: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_type") || "请输入属性类型",
            trigger: "blur",
          },
        ],
        resAttributeName: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name") || "请输入中文名称",
            trigger: "blur",
          },
        ],
        resAttributeNameEn: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_name_en") ||
              "请输入英文名称",
            trigger: "blur",
          },
        ],
        resAttributeStatus: [
          {
            required: true,
            message: this.$l("form_rule_message_status") || "请选择有效状态",
            trigger: "blur",
          },
        ],
        resAttributeDescription: [
          {
            required: true,
            message:
              this.$l("form_rule_message_attribute_desc") || "请输入属性说明",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.resAttributeCode) return;

      this.$api
        .detailResearchDictionaryApi({
          resAttributeCode: this.resAttributeCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) {
        return;
      }
      this.loadingOpen();
      this.$api
        .saveResearchDictionaryApi(this.formData)
        .then((res) => {
          this.loadingClose();
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_save_ok") || res.msg,
            type: "success",
          });
          this.$emit("close");
          this.$emit("reload");
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.openQuestion();
    },
    close() {
      this.$emit("close");
    },
    openQuestion() {
      this.$confirm(
        this.$l("INDEX.tips_question_save") || "是否要保存更改",
        this.$l("INDEX.tips_question_title") || "提示信息",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l("INDEX.btn_save") || "保存",
          cancelButtonText: this.$l("INDEX.btn_no_save") || "不保存",
        }
      )
        .then(() => {
          this.save();
        })
        .catch((action) => {
          if (action === "cancel") {
            this.close();
          }
        });
    },
  },
};
</script>
